// extracted by mini-css-extract-plugin
module.exports = {"loadingScreen":"LoadingScreen_loadingScreen__29b_S colors_darkBackground__3mYv1","loadingText":"LoadingScreen_loadingText__2S-Mq"};